import { BpDevInfoComponent } from './dev-info/dev-info.component'

export const COMPONENTS = [BpDevInfoComponent]
